import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FormControl from "@mui/material/FormControl";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { Button } from "@material-tailwind/react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MyDomain } from "../../App";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Phone } from "@mui/icons-material";
import dayjs from "dayjs";
import LottifileLoading from "../../LottifileLoading.json";
import Lottie from "lottie-react";
import DialogTitle from "@mui/material/DialogTitle";
//import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1920
        ? "90%"
        : window.innerWidth <= 2560
        ? "70%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

export default function CheckOutPersonalInfoBlock() {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {}, []);

  const [FirstName, setFirstName] = useState(user.firstName);
  const [LastName, setLastName] = useState(user.lastName);
  const [Email, setEmail] = useState(user.email);

  // Check user.dateOfBirth and parse it

  // To display or format the date

  const [PhoneNumber, setPhoneNumber] = useState(user.phoneNumber);
  const [PhoneNumberDataBase, setPhoneNumberDataBase] = useState("");
  const [Password, setPassword] = useState("");
  const [Password2, setPassword2] = useState("");
  const [OldPassword, setOldPassword] = useState("");
  const [CheckOldPassword, setCheckOldPassword] = useState(user.password);
  const [DateOfBirthErr, setDateOfBirthErr] = React.useState(false);

  const [value, setValue] = useState(dayjs("1998-01-17"));
  // Assuming user.dateOfBirth is "17-01-1998"
  // const [DateOfBirth, setDateOfBirth] = useState(
  //   dayjs(user.dateOfBirth, "DD-MM-YYYY")
  // );

  const [DateOfBirth, setDateOfBirth] = useState(null);
  useEffect(() => {
    // Assuming user.dateOfBirth is in 'DD-MM-YYYY' format.
    const user = JSON.parse(localStorage.getItem("user")); // Example of retrieving from localStorage
    if (user && user.dateOfBirth) {
      setDateOfBirth(dayjs(user.dateOfBirth, "DD-MM-YYYY"));
    }
  }, []);

  const [responseMessage, setResponseMessage] = useState("");
  const [ReceiveNotifications, setReceiveNotifications] = useState("0");
  const [ErrorPassword, setErrorPassword] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const [showPassword2, setShowPassword2] = React.useState(false);

  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

  const handleMouseDownPassword2 = (event) => {
    event.preventDefault();
  };

  const [showPassword3, setShowPassword3] = React.useState(false);

  const handleClickShowPassword3 = () => setShowPassword3((show) => !show);

  const handleMouseDownPassword3 = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword2 = (event) => {
    event.preventDefault();
  };
  const ReceiveNotificationsFunc = (event) => {
    setReceiveNotifications(event.target.checked ? "1" : "0");
  };

  const handleSubmit = (event) => {
    const formattedDate = DateOfBirth.format("DD-MM-YYYY");
    //event.preventDefault();

    // const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // regex.test(Email);
    // if (regex.test(Email)) setEmailErr(false);
    // else setEmailErr(true);

    // if (FirstName.length >= 2) setFirstNameErr(false);
    // else setFirstNameErr(true);

    // if (LastName.length >= 2) setLastNameErr(false);
    // else setLastNameErr(true);

    // if (Password !== Password2 || Password.length < 2 || Password2 < 2) {
    //   setErrorPassword(true);
    //   return;
    // } else setErrorPassword(false);
    // if (FirstNameErr || LastNameErr || EmailErr) {
    //   console.log("should return!");
    //   return;
    // }
    const data = {
      Users: {
        Id: user?.userId,
        FirstName: FirstName,
        LastName: LastName,
        Email: Email,
        DateOfBirth: formattedDate, //"17-01-1998", //formattedDate, //DateOfBirth,
        PhoneNumber: PhoneNumber,
        Password: OldPassword,
      },
      NewPassword: Password,
    };
    axios
      .put(`${MyDomain}Users/UpdateUser`, data) // replace with your API URL
      .then((response) => {
        console.log(response.data);
        setResponseMessage("Data submitted successfully!");
        user.firstName = FirstName;
        user.lastName = LastName;
        user.Email = Email;
        user.dateOfBirth = formattedDate; //"17-01-1998"; //formattedDate; //DateOfBirth; //"17-01-1998"; //DateOfBirth;
        user.phoneNumber = PhoneNumber;
        localStorage.setItem("user", JSON.stringify(user));
        // setOpenDone(true);
        // setEmailErr(false);
        // setFirstNameErr(false);
        // setLastNameErr(false);
        // setOldPasswordErr(false);
        setErrorPassword(false);
        setPassword("");
        setPassword2("");
        setOldPassword("");
        setCheckOldPassword(user.Password);
      })
      .catch((err) => {
        setResponseMessage("Error submitting data.");
        console.error(err.response.data);
      });
  };
  const prefix = "+972";

  const handlePhoneChange = (e) => {
    let inputValue = e.target.value;

    // Ensure the input starts with the prefix
    if (!inputValue.startsWith(prefix)) {
      inputValue = prefix;
    }

    // Extract the digits after the prefix
    let phoneDigits = inputValue.slice(prefix.length);

    // Remove extra spaces in case the user tries to add multiple spaces
    phoneDigits = phoneDigits.replace(/\s+/g, "");

    // Insert a space after the first two digits
    if (phoneDigits.length > 2) {
      phoneDigits = phoneDigits.slice(0, 2) + " " + phoneDigits.slice(2);
    }
    const modifiedText = prefix.replace(/[()]/g, "");
    setPhoneNumberDataBase(prefix + phoneDigits);
    setPhoneNumber(prefix + " " + phoneDigits);
  };

  const handleFocus = () => {
    if (!PhoneNumber.startsWith(prefix)) {
      setPhoneNumber(prefix);
    }
  };
  const [openCart, setOpenCart] = useState(false);

  const handleClickOpen = async () => {
    setOpenCart(true);
  };
  const handleClose = () => {
    setOpenCart(false);
  };

  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "50%",
      }}
    >
      <React.Fragment>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={openCart}
          //fullWidth
          maxWidth={false} // Disable Material-UI's default width settings
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {t("profile.ContactInfo")}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              paddingBottom: 40,
            }}
          >
            <div
              style={{
                flexDirection: "row",
                justifyContent: "space-around",
                width: "100%",
                display: "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyItems: "flex-start",
                }}
              >
                <p> </p>
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "space-around",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      width: "40%",
                      alignItems: "flex-start",
                    }}
                  >
                    <TextField
                      id="standard-basic"
                      label={t("profile.Firstname")}
                      variant="standard"
                      style={{
                        paddingBottom: 45,
                        width: "100%",
                        maxWidth: 500,
                      }}
                      InputLabelProps={{
                        style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                      }}
                      value={FirstName} // Bind the state value to the TextField
                      onChange={(e) => setFirstName(e.target.value)} // Update state on input change
                    />
                    <TextField
                      id="standard-basic"
                      label={t("profile.Lastname")}
                      variant="standard"
                      style={{
                        paddingBottom: 45,
                        width: "100%",
                        maxWidth: 500,
                      }}
                      InputLabelProps={{
                        style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                      }}
                      value={LastName} // Bind the state value to the TextField
                      onChange={(e) => setLastName(e.target.value)} // Update state on input change
                    />

                    <div
                      style={{
                        width: "100%",
                        maxWidth: 500,
                        paddingBottom: 45,
                      }}
                    >
                      {/* Ensures the container is 100% width */}
                      <p style={{ margin: 0, fontSize: 12, opacity: 0.5 }}>
                        {t("profile.Dateofbirth")}
                      </p>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={DateOfBirth}
                          onChange={(newValue) => setDateOfBirth(newValue)}
                          slotProps={{
                            textField: {
                              variant: "standard", // Removes outer border and keeps only the underline
                              InputProps: {
                                disableUnderline: false, // Ensure underline is shown
                              },
                              sx: {
                                width: "100%", // Enforces full width on the text field
                                "& .MuiInputBase-root:before": {
                                  borderBottom: "1px solid rgba(0, 0, 0, 0.42)", // Regular underline color
                                },
                                "& .MuiInputBase-root:hover:not(.Mui-disabled):before":
                                  {
                                    borderBottom: "1px solid black", // Underline color on hover
                                  },
                                "& .MuiInputBase-root:after": {
                                  borderBottom: "2px solid #1976d2 ", // Underline color when focused
                                },
                              },
                            },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              sx={{
                                width: "100%", // Ensures TextField spans full width
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: "red", // Default border color
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "red", // Hover border color
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "red", // Focus border color
                                  },
                                },
                              }}
                            />
                          )}
                        />
                        {DateOfBirthErr ? (
                          <>
                            <a style={{ color: "red", fontSize: 14 }}>
                              Please check Date
                            </a>
                          </>
                        ) : (
                          <></>
                        )}
                      </LocalizationProvider>
                    </div>

                    <TextField
                      id="standard-basic"
                      label={t("profile.Phone")}
                      variant="standard"
                      style={{
                        paddingBottom: 45,
                        width: "100%",
                        maxWidth: 500,
                      }}
                      InputLabelProps={{
                        style: { opacity: 0.5, fontSize: "15px" },
                      }}
                      value={PhoneNumber}
                      onChange={handlePhoneChange}
                      onFocus={handleFocus}
                    />
                    <TextField
                      id="standard-basic"
                      label={t("profile.email")}
                      variant="standard"
                      style={{
                        paddingBottom: 45,
                        width: "100%",
                        maxWidth: 500,
                      }}
                      InputLabelProps={{
                        style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                      }}
                      value={Email} // Bind the state value to the TextField
                      onChange={(e) => setEmail(e.target.value)} // Update state on input change
                    />
                  </div>
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      width: "40%",
                    }}
                  >
                    <FormControl
                      variant="standard"
                      style={{
                        paddingBottom: 45,
                        width: "100%",
                        maxWidth: 500,
                      }}
                    >
                      <InputLabel
                        htmlFor="standard-adornment-password"
                        sx={{ opacity: 0.5, fontSize: "15px" }} // Style for the label
                      >
                        {t("profile.Oldpassword")}
                        {/* Add asterisk to indicate required */}
                      </InputLabel>
                      <Input
                        id="standard-adornment-password"
                        type={showPassword3 ? "text" : "password"}
                        value={OldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword3}
                              onMouseDown={handleMouseDownPassword3}
                            >
                              {showPassword ? (
                                <VisibilityOff fontSize="small" />
                              ) : (
                                <Visibility fontSize="small" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    <FormControl
                      variant="standard"
                      style={{
                        paddingBottom: 45,
                        width: "100%",
                        maxWidth: 500,
                      }}
                    >
                      <InputLabel
                        htmlFor="standard-adornment-password"
                        sx={{ opacity: 0.5, fontSize: "15px" }} // Style for the label
                      >
                        {t("profile.NewPassword")}
                        {/* Add asterisk to indicate required */}
                      </InputLabel>
                      <Input
                        id="standard-adornment-password"
                        type={showPassword ? "text" : "password"}
                        value={Password}
                        onChange={(e) => setPassword(e.target.value)}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityOff fontSize="small" />
                              ) : (
                                <Visibility fontSize="small" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    <FormControl
                      variant="standard"
                      style={{
                        paddingBottom: 45,
                        width: "100%",
                        maxWidth: 500,
                      }}
                    >
                      <InputLabel
                        htmlFor="standard-adornment-password"
                        sx={{ opacity: 0.5, fontSize: "15px" }} // Style for the label
                      >
                        Confirm password
                        {/* Add asterisk to indicate required */}
                      </InputLabel>
                      <Input
                        id="standard-adornment-password"
                        type={showPassword2 ? "text" : "password"}
                        value={Password2}
                        onChange={(e) => setPassword2(e.target.value)}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword2}
                              onMouseDown={handleMouseDownPassword2}
                            >
                              {showPassword2 ? (
                                <VisibilityOff fontSize="small" />
                              ) : (
                                <Visibility fontSize="small" />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    {!ErrorPassword ? (
                      <></>
                    ) : (
                      <>
                        <p style={{ color: "red" }}>
                          Pleas check your password !
                        </p>
                      </>
                    )}
                  </div>
                </div>
                <button
                  style={{
                    borderWidth: 0,
                    backgroundColor: "white",
                    border: "1px solid black",
                    marginLeft: "5%",
                    color: "black",
                    marginTop: 45,
                    height: 50,
                    width: "25%",
                    maxWidth: 150,
                    minWidth: 120,
                  }}
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  {t("profile.Save")}
                </button>
              </div>
            </div>
          </div>
        </BootstrapDialog>
      </React.Fragment>
      <a style={{ fontWeight: "500", fontSize: 18 }}>
        {t("profile.Firstandlastname")}
      </a>
      <a style={{ fontSize: 14, paddingBottom: 15 }}>
        {FirstName} {LastName}
      </a>
      <a style={{ fontWeight: "500", fontSize: 18 }}>{t("profile.email")}</a>
      <a style={{ fontSize: 14, paddingBottom: 15 }}>{Email}</a>
      <a style={{ fontWeight: "500", fontSize: 18 }}>{t("profile.Phone")}</a>
      <a style={{ fontSize: 14, paddingBottom: 25 }}>{PhoneNumber}</a>
      <div>
        {/* <a
          style={{
            cursor: "pointer",
            fontSize: 14,
            color: hovered ? "#6b21a8" : "black", // Change color on hover
          }}
          onClick={handleClickOpen}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {t("profile.Changecontactinfo")}
        </a> */}
      </div>
    </div>
  );
}
